/*
 * @Description:
 * @Version: 1.0
 * @Autor: hekai
 * @Date: 2021-07-07 14:18:31
 * @LastEditors: hekai
 * @LastEditTime: 2021-07-10 16:20:30
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import user from './modules/user'
import general from './modules/general'
/**
 * 解决vue-router3.0以上报错问题
 * @type {{(location: RawLocation): Promise<Route>; (location: RawLocation, onComplete?: Function, onAbort?: ErrorHandler): void}}
 */
// const originalPush = VueRouter.prototype.push;
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err);
// };
/**
 * 解决vue-router3.0以上报错问题
 * @type {{(location: RawLocation): Promise<Route>; (location: RawLocation, onComplete?: Function, onAbort?: ErrorHandler): void}}
 */
try {
  const originalPush = VueRouter.prototype.push
  VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
  }
} catch (e) {
}

Vue.use(VueRouter)

const routes = [
  ...general,
  ...user
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
